import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { adminStore, adminPersistor } from 'src/redux/adminStore';

export default function AdminStoreProvider({ children }) {
  return (
    <Provider store={adminStore}>
      <PersistGate loading={null} persistor={adminPersistor}>
        {children}
      </PersistGate>
    </Provider>
  );
}

AdminStoreProvider.propTypes = {
  children: PropTypes.node,
};
